import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import { Title } from '../components/Recovery/ForgotPages.styles'
import { Form, Expired } from './components'
import { CODE_LINK_EXPIRED, CODE_SAME_PASSWORD } from './constants'
import Banner from 'components/common/Banner/Banner'

const ResetPasswordWrapper = ({
  path,
  status: {
    code,
    description
  },
  samePassError: {
    code: samePassErrorCode,
    description: samePassErrorDescription
  },
  ...props
}) =>
  <Container>
    <Title>Reset Password</Title>
    { samePassErrorCode === CODE_SAME_PASSWORD &&
      <Banner error_alternative hidden={ !samePassErrorDescription }>
        { samePassErrorDescription }
      </Banner>
    }
    {
      code === CODE_LINK_EXPIRED ?
        <Expired path={ path } expiredError={ description } /> :
        <Form { ...props } />
    }
  </Container>

ResetPasswordWrapper.propTypes = {
  path: PropTypes.string,
  samePassError: PropTypes.shape(),
  status: PropTypes.shape({
    code: PropTypes.string,
    description: PropTypes.string
  })
}

export default ResetPasswordWrapper

const Container = styled.div`
  width: 400px;
  padding: 20px 0;
  margin: 0 auto;
  ${Media.mobile`
    width: 100%;
    padding: 20px;
  `}
`
